module.exports = __webpack_public_path__ + "img/a89d6ad1-a04f-4a8f-b140-e55478dbea80.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/a89d6ad1-a04f-4a8f-b140-e55478dbea80.svg
// module id = 187
// module chunks = 245 246